import { Theme } from '@material-ui/core';
import { CSSProperties } from 'react';
import { FsComponentSize } from 'globals/types';
import { Color } from '@material-ui/lab';

export type PaddingSizeType =
  | FsComponentSize.XS
  | FsComponentSize.S
  | FsComponentSize.M;

export const getPaddingValue = (
  paddingSize: PaddingSizeType,
  { spacing }: Theme
): number | undefined => {
  switch (paddingSize) {
    case FsComponentSize.XS:
      return 0;
    case FsComponentSize.S:
      return spacing(2.5);
    default:
      return undefined;
  }
};

export interface GetContainerStyle {
  style?: CSSProperties;
  paddingSize: PaddingSizeType;
  withShadow: boolean;
  theme: Theme;
}

export const getContainerStyle = ({
  style,
  paddingSize,
  withShadow,
  theme,
}: GetContainerStyle): CSSProperties => ({
  boxShadow: !withShadow ? 'none' : undefined,
  padding: getPaddingValue(paddingSize, theme),
  ...style,
});

export const getContentStyle = (withContentMargin: boolean): CSSProperties => ({
  marginTop: !withContentMargin ? 0 : undefined,
});

export const getLinkStyle = (): CSSProperties => ({
  textDecoration: 'none',
});

interface AlertProps {
  severity: Color;
  isContent: boolean;
}

export const getAlertWrapperBoxStyle = ({
  palette,
  spacing,
  severity,
  isContent,
}: Theme & AlertProps): CSSProperties => ({
  borderLeft: isContent ? `1px solid ${palette[severity].main}` : undefined,
  paddingLeft: isContent ? spacing(2) : undefined,
});
